<div class="library-card" [class.folder]="item.type === libraryTypes.FOLDER" (click)="openLibraryItem()" [attr.data-cy]="'library-item-' + item.id">
  <div
    class="library-card-preview"
    [cropImage]="previewImage | preSignedUrl : entityTypeId.NODE : bundleType.LIBRARY : fieldName | async"
    [crop]="previewImage?.crop"
    [imageWidth]="400">

    <div class="library-card-indicators">
      @if (isNew) {
        <div class="library-indicator">{{'COMMON.new' | translate}}</div>
      }

      @if (item?.userPin) {
        <div class="library-indicator">{{'LIBRARY.pinned' | translate}}</div>
      }
    </div>

    @if (!previewImage) {
      <lib-library-item-icon class="d-sm-none library-icon" [item]="item" [size]="32"></lib-library-item-icon>
      <lib-library-item-icon class="d-none d-sm-block library-icon" [item]="item"></lib-library-item-icon>
    }
  </div>

  <div class="library-card-footer">
    <div class="library-card-title-container">
      <div class="library-card-title">
        <lib-library-item-icon [item]="item" [size]="24"></lib-library-item-icon>
        {{ item.name }}
      </div>

      @if (contextTemplate) {
        <button
          mat-icon-button
          aria-label="Context menu"
          class="button button--icon button--icon-extra-small library-card-context-button"
          (click)="stopPropagation($event)"
          [matMenuTriggerFor]="matMenu"
          data-cy="library-card-context-menu">
          <lib-icon class="context-menu-icon" icon="dots-three-vertical" [bold]="true" [size]="16"></lib-icon>
        </button>
        <mat-menu class="lib-panel-menu" #matMenu="matMenu">
          <ng-container *ngTemplateOutlet="contextTemplate; context: { item: item }"></ng-container>
        </mat-menu>
      }
    </div>

    <div class="library-card-info">
      @if (item.parent; as parentFolder) {
        <div class="library-card-info__item library-card-info__parent">
          <lib-icon [size]="16" icon="folder-notch-open"></lib-icon>
          <span class="parent-folder" ellipsis [ellipsis-content]="parentFolder.title"></span>
        </div>
      }


      @if (item.type === libraryTypes.FOLDER && (item.childrenAmount || !item.hasChildrenFolders)) {
        <div class="library-card-info__item">
          <lib-icon icon="files" [size]="16"></lib-icon>
          {{ 'LIBRARY_PAGE.folder_files' | translate : { count: item.childrenAmount } }}
        </div>
      }

      @if (item.type === libraryTypes.FILE && item.file?.fileSize) {
        <div class="library-card-info__item">
          {{ item.file.fileSize | fileSize:0 }}
        </div>
      }

      @if (!hideUpdatedDate) {
        <div class="library-card-info__item">
          <lib-icon [size]="16" icon="clock-clockwise"></lib-icon>
          {{ item.updated | customDate: 'short' }}
        </div>
      }
    </div>
  </div>
</div>
